/** Urdu (Nastaliq) names for Pakistan city slugs used across /pakistan/urdu/* pages. */
export const PAKISTAN_CITY_URDU: Record<string, string> = {
  karachi: "کراچی",
  lahore: "لاہور",
  islamabad: "اسلام آباد",
  rawalpindi: "راولپنڈی",
  peshawar: "پشاور",
  quetta: "کوئٹہ",
  multan: "ملتان",
  faisalabad: "فیصل آباد",
  "hyderabad-pk": "حیدرآباد",
  sialkot: "سیالکوٹ",
  gujranwala: "گوجرانوالہ",
  bahawalpur: "بہاولپور",
  sargodha: "سرگودھا",
  sahiwal: "ساہیوال",
  sheikhupura: "شیخوپورہ",
  sukkur: "سکھر",
  larkana: "لاڑکانہ",
  mardan: "مردان",
  abbottabad: "ایبٹ آباد",
  "toba-tek-singh": "ٹوبہ ٹیک سنگھ",
  jhang: "جھنگ",
};

export function urduCityName(slug: string, fallback: string): string {
  return PAKISTAN_CITY_URDU[slug] ?? fallback;
}